function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", {
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("style", null, ".history-icon{fill:url(#history);}"), /*#__PURE__*/React.createElement("radialGradient", {
  id: "history",
  x1: 35,
  y1: 8.1,
  x2: 35,
  y2: 62.1,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "40%",
  stopColor: "#038FC7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#00008B"
})));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "history-icon",
  d: "M31.4057,33.54956H52.343l.11151-.00415a1.49555,1.49555,0,0,0-.11151-2.98694H31.4057l-.11157.00415a1.49555,1.49555,0,0,0,.11157,2.98694Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "history-icon",
  d: "M31.4057,48.50476H46.3609l.11157-.00409a1.49555,1.49555,0,0,0-.11157-2.98694H31.4057l-.11157.00409a1.49555,1.49555,0,0,0,.11157,2.98694Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "history-icon",
  d: "M31.4057,63.46H43.36987l.11158-.00409a1.49556,1.49556,0,0,0-.11158-2.98694H31.4057l-.11157.00409A1.49555,1.49555,0,0,0,31.4057,63.46Z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "history-icon",
  d: "M96.939,29.18231A10.46867,10.46867,0,0,0,82.134,14.37738l-2.1145,2.11469a1.49551,1.49551,0,0,0-.43823,1.05731v4.85l-1.67725-1.67724a1.53941,1.53941,0,0,0-2.11474,0l-4.00415,4.00506v-10.438a7.49059,7.49059,0,0,0-7.45533-7.4776L7.48212,6.62982H7.4776a7.4776,7.4776,0,0,0,0,14.9552,1.49552,1.49552,0,1,0,0-2.991,4.47533,4.47533,0,1,1,4.48657-4.48657v71.7851a7.4861,7.4861,0,0,0,7.4776,7.4776h1.42377a8.98306,8.98306,0,0,0,1.11493-.06879,1.50633,1.50633,0,0,0,.45239.06879H70.28955A8.897,8.897,0,0,0,71.78516,75.702V54.33551ZM20.86554,90.37909c-.08746,0-.17426-.009-.261-.0127a5.9284,5.9284,0,0,1-5.64935-5.89758V14.10742a7.4266,7.4266,0,0,0-1.49548-4.4671l50.86047.16223a4.49421,4.49421,0,0,1,4.47388,4.48657V27.7182L52.525,43.98724a1.49287,1.49287,0,0,0-.40905,1.35047l1.95764,9.7904-5.77869,5.77875a1.49529,1.49529,0,1,0,2.11469,2.11462l5.77868-5.77868L65.978,59.20044a1.49455,1.49455,0,0,0,1.35107-.409l1.465-1.4649V75.56671H20.86554a1.49552,1.49552,0,1,0,0,2.991,5.91068,5.91068,0,1,1,0,11.82135ZM76.2,84.46881a5.93934,5.93934,0,0,1-5.9104,5.91028H27.51611a8.88406,8.88406,0,0,0,0-11.82135H70.28955A5.93933,5.93933,0,0,1,76.2,84.46881ZM68.79407,53.09723l-3.01428,3.01349-7.04987-1.40955L71.55933,41.87183a1.49536,1.49536,0,0,0-2.11475-2.11469L56.61523,52.58649l-1.40948-7.05066L76.84668,23.8949l3.17285,3.172a1.49505,1.49505,0,0,0,2.55274-1.05731V18.16925l1.67724-1.67718A7.47753,7.47753,0,0,1,94.82434,27.06689Z"
});

function SvgHistory(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/history.36e3e7e2.svg";
export { ForwardRef as ReactComponent };